import React from 'react';

const EventContext = React.createContext();

export default EventContext;